import { Button, Form, message, Space, Drawer } from "antd";
import formatMoney from "../../../../utils/formatMoney";
import deleteDataRoad from "../../../../services/deleteDataRoad";
import { AiOutlineClose } from "react-icons/ai";


export default function DeleteOffer({ isVisible, setVisible, offer,refetch }: any) {

  const [form] = Form.useForm();


  const getTotal = (item: any) => {
    let total = 0;
    total = item?.partsrate + item?.labourrate * item?.flattime;
    return isNaN(total) ? 0 : total;
  };



  const onSubmit = async () => {
    const uri = `offers/${offer?._id}`;
    const response = await deleteDataRoad(uri);
    if (response?.success) {
      message.success("Deleted Successfully");
      refetch();
      setVisible(false);
    }
  };

  return (

    <Drawer
    title={`DELETE: ${offer?.callout_desc}`}
    placement={"right"}
    width={800}
    onClose={() => setVisible(!isVisible)}
    visible={isVisible}
    closable={false}
    extra={
      <Space>
        <Button
          type="default"
          color="#E50000"
          onClick={() => setVisible(!isVisible)}
          danger
        >
          <AiOutlineClose />
        </Button>
      </Space>
    }
  >
      <Form
        id="deleteOffer"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-col items-start justify-center">
          <p className="text-center font-bold">
            Are you sure you want to{" "}
            <span className="text-red-600 font-bold">delete</span> this offer
          </p>
          <p className="text-center font-bold">{offer?.callout_desc}</p>
          <p className="text-center font-bold">
            {formatMoney(getTotal(offer) * 1.18)}
          </p>
        </div>

        <Form.Item>
            <Button danger type="primary" htmlType="submit">
              Delete
            </Button>
            <Button
              danger
              htmlType="button"
              className="mx-2"
              onClick={() => setVisible(!isVisible)}
            >
              Cancel
            </Button>
          </Form.Item>
      </Form>
    </Drawer>
  );
}
